export interface IMedium {
  id: number
  url: string
  thumbnail_url: string
  width: number
  height: number
  created_at: Date
}

export class Medium {
  id: number
  url: string
  thumbnail_url: string
  width: number
  height: number
  created_at: Date

  constructor(defaults?: IMedium) {
    if (defaults) {
      this.id = defaults.id
      this.url = defaults.url
      this.thumbnail_url = defaults.thumbnail_url
      this.width = defaults.width
      this.height = defaults.height
      this.created_at = defaults.created_at
    }
  }
}
